<div class="top-padding">
  <div class="structural-formula-container">
    <div class="usan-checklist-item">
      <div class="usan-checklist-icon-column">
        <mat-icon>{{ hasStructuralFormula ? 'check_circle' : 'radio_button_unchecked' }}</mat-icon>
      </div>
      <div class="usan-checklist-content-column">
        <span class="required-star" *ngIf="isDocumentRequired">*</span>
        <span class="usan-form-item structural-formula-item structural-formula-text" [innerHTML]="displayText">
        </span>
      </div>
    </div>
    <div class="structural-formula-secondary-text structural-formula-text">
      <span *ngIf="isSingleEntityStructuralFormulaInputType || isFormAType" [innerHTML]="secondaryText"></span>
    </div>
    <div class="structural-formula-secondary-text structural-formula-text">
      <span *ngIf="isFormEType" [innerHTML]="tertiaryText"></span>
    </div>
    <div class="input-error" *ngIf="showRequiredError">
      This is a required document.
    </div>
    <div class="usan-form-item button-layout layout-centered">
      <button type="button" class="upload-structural-formula form-btn form-btn-style form-btn-text"
        (click)="openDialog()">
        <mat-icon class="form-btn-icon">upload</mat-icon>
          {{ formFieldTitle }}
      </button>
    </div>
  </div>
  <ng-container *ngIf="hasStructuralFormula">
    <div class="full-width" *ngFor="let file of attachments">
      <app-uploaded-file [requiresAdmin]="false" [attachment]="file"></app-uploaded-file>
    </div>
  </ng-container>
</div>